import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Search } from "@mui/icons-material";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SlotCountTable from "../components/SlotCountTable";
import SlotCountForm from "../components/SlotCountForm";
import { useSlotCount } from "../hooks/useSlotCount";

const SlotCountMasterPage = () => {
  const {
    open,
    columns,
    loading,
    formValues,
    isDisabled,
    errorMessage,
    vehicleTypeOptions,
    parkingOptions,
    rows,
    setOpen,
    handleClose,
    handleOpenForm,
    findDuplicateSlotCount,
    handleInputChange,
    handleSearchChange,
  } = useSlotCount();
  return (
    <>
      <Typography className="text-[#252F40] !mb-2">
        <Link to="/dashboard" className="no-underline">
          <span className="text-[#8C8C8C]">Masters / </span>
        </Link>
        Slot Count
      </Typography>
      <Box
        sx={{
          boxShadow: " 0px 5px 15px -2px rgba(0, 0, 0, 0.12)",
          borderRadius: "2rem",
          width: "100%",
        }}
      >
        <Box className="flex justify-between px-3 py-2 items-center bg-[white]">
          <Box display="flex" p={1} alignItems="center">
            <TextField
              label="Search"
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Button
            variant="contained"
            onClick={handleOpenForm}
            className="!bg-[#3A416F] gap-2"
          >
            Add <AddBoxRoundedIcon />
          </Button>
          <SlotCountForm
            {...{
              open,
              formValues,
              isDisabled,
              errorMessage,
              handleClose,
              handleInputChange,
              findDuplicateSlotCount,
              vehicleTypeOptions,
              parkingOptions,
            }}
          />
        </Box>
        <SlotCountTable columns={columns} loading={loading} rows={rows} />
      </Box>
    </>
  );
};

export default SlotCountMasterPage;
